import script from "./myRankCard.vue?vue&type=script&setup=true&lang=js"
export * from "./myRankCard.vue?vue&type=script&setup=true&lang=js"

import "./myRankCard.vue?vue&type=style&index=0&id=e6dea664&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6dea664"]])

export default __exports__